import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

const SearchFilter = (props) => (
  <Paper
    sx={{
      p: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: "auto",
      margin: 2,
    }}
  >
    <IconButton disabled sx={{ p: "10px" }}>
      <MenuIcon />
    </IconButton>
    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
    <InputBase
      sx={{ ml: 1, flex: 1 }}
      placeholder={props.placeholder}
      onChange={props.handleChange}
      value={props.val}
    />
    <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
    <IconButton disabled sx={{ p: "10px" }}>
      <SearchIcon />
    </IconButton>
  </Paper>
);

export default SearchFilter;
